import { environment } from '@/environment';
import { AuthData } from '@/models/auth';
import { LoginData } from '@/models/login';
import { errorMessage } from '@/store/types';
import axios, { AxiosError, AxiosResponse } from 'axios';

export default {
  url: `${environment.api}/authentication`,

  postToken(loginData: LoginData): Promise<AuthData | string> {
    const loginDto: LoginDTO = {
      login: loginData.email,
      password: loginData.password,
    };

    return axios
      .post<AuthData>(`${this.url}/token`, loginDto)
      .then((response: AxiosResponse<AuthData>) => {
        const { data } = response;
        return Promise.resolve(data);
      })
      .catch((error: AxiosError) => {
        return Promise.reject(error.response?.data.message);
      });
  },

  postRecover(email: string): Promise<AxiosResponse<any>> {
    return axios.post(`${this.url}/password-reset`, { email });
  },

  putNewPassword(
    password: string,
    token: string
  ): Promise<AxiosResponse<any | errorMessage>> {
    return axios
      .put(`${this.url}/password-reset/${token}`, { password })
      .then(res => res)
      .catch((error: AxiosError) => {
        if (error.message.includes('403')) {
          return Promise.reject({
            message: 'The provided token in not valid anymore or has expired.',
          });
        }

        return Promise.reject({
          message: 'The password reset token was not found.',
        });
      });
  },
};

export type LoginDTO = {
  login: string;
  password: string;
};
